import { ReactComponent as ArrowSVG } from '@/asset/svg/arrow.svg'
import TGASDK from '@/config/TGASDK'
import useInviteRewardConfig from '@/hook/useInviteRewardConfig'
import { PopUpStore } from '@/store/PopupStore'
import React from 'react'
import { useTranslation } from 'react-i18next'
import InvitePopup from '../../InvitePopup'

const InviteCard: React.FC<PropType> = () => {
  const { t } = useTranslation('invite')
  const { data } = useInviteRewardConfig()

  const handleClick = () => {
    PopUpStore.setInvitePopupVisible(true)
  }

  if (!TGASDK.context.appConfig.feature.share.enabled || !data?.diamondReward) {
    return null
  }

  return (
    <>
      <div
        className="flex justify-between items-center bg-white p-md rounded-md cursor-pointer hover:bg-opacity-80"
        onClick={handleClick}
      >
        <img src={require('@/asset/image/invite_rewards.png')} alt="invite" className="h-10" />
        <div>
          <div className="font-semibold">{t('tip.noticeTitle')}</div>
          <p className="text-fontcolor-400">{t('tip.noticeContent')}</p>
        </div>
        <ArrowSVG className="rotate-180 w-5 h-5 fill-fontcolor-400" />
      </div>
      <InvitePopup />
    </>
  )
}

interface PropType {}

export default InviteCard
